import axios from "axios"
import * as api from '../api/compras-notificacion.api'
let token = sessionStorage.getItem('token');

export default class ComprasNotificacionService {

    config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    last = async () => {
        try {
            const response = await axios.get(api.last, this.config)
            if (response.status === 200 || response.status === 201) return response.data
            else throw new Error("Error en la obtención de las últimas notificaciones");
        } catch (error) {
            return { error: error };
        }
    }

    list = async ({ page, limit } = {}) => {
        try {
            const response = await axios.post(api.list, { page, limit }, this.config)
            if (response.status === 200 || response.status === 201) return response.data
            else throw new Error("Error en la obtención de las notificaciones");
        } catch (error) {
            return { error: error };
        }
    }

    marcarLeida = async ({ id }) => {
        try {
            const response = await axios.post(api.marcarLeida, { id }, this.config)
            if (response.status === 200 || response.status === 201) return response.data
            else throw new Error("Error al marcar la notificación como leída");
        } catch (error) {
            return { error: error };
        }
    }

    marcarTodasLeidas = async () => {
        try {
            const response = await axios.post(api.marcarTodasLeidas, {}, this.config)
            if (response.status === 200 || response.status === 201) return response.data
            else throw new Error("Error al marcar las notificaciones como leídas");
        } catch (error) {
            return { error: error };
        }
    }

}
